<template>
  <div id = "planArchive">
    <!-- 归档管理 -->
    <ots-main-title></ots-main-title>
    <!-- 搜索框 -->
    <div class="searchCon">
      <div class="searchMain">
        <ots-refer :selectList="selectList" :request-form="requestForm" @search="searchList" />
      </div>
    </div>
    <!-- table 表格 -->
    <ots-table-group-new
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeSize"
      @changePage="changePage"
    ></ots-table-group-new>

    <!-- 下载弹出框 -->
    <ots-custom-dialog
      :dialog.sync="downDialog"
      :show-close.sync="showCloseFlag"
      :title="isAddDesc"
      width="800px"
    >
      <template v-slot:content>
        <div class="exportDialog">
          <div class="batch-name">
            <strong>批次名称：</strong>{{ planName }}
          </div>

          <el-table
            :data="fileList"
            style="width: 100%"
            @row-click="handleDownload"
            :row-style="{ cursor: 'pointer' }"
            class="file-table"
          >
            <el-table-column label="文件名" width="480">
              <template #default="{ row }">
                <i class="el-icon-document file-icon"></i>
                <span class="file-name">{{ row.archiveFileName }}</span>
              </template>
            </el-table-column>

            <el-table-column label="文件大小">
              <template #default="{ row }">
                <span class="file-size">{{ formatFileSize(row.archiveFileSize) }}</span>
              </template>
            </el-table-column>

            <el-table-column label="下载次数">
              <template #default="{ row }">
                <span class="download-count">{{ row.downloadCount }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="downDialog = false">关闭</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>

<script>
import {getPagePlan} from "@/http/modules/examSet/examBatch";

import {
  getPlanArchiveListApi,
  getPlanArchiveListFileApi,
  planArchiveArchiveOperateApi,
  planArchiveDownloadOperateApi,
  planArchiveDeleteOperateApi
 } from "@/http/modules/dataV";

export default {
  name: "planArchive",
  data() {
    return {
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          isSearch: true,
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '批次状态',
          type: 'select',
          requestKey: "enableState",
          label: 'name',
          value: 'id',
          data: [
            { name : '全部', id : "" },
            { name : '启用', id : 1 },
            { name : '停用', id : 0 }
          ],
        },
        {
          title: '归档状态',
          type: 'select',
          requestKey: 'archiveState',
          label: 'name',
          value: 'id',
          data: [
            { name : '全部', id : "" },
            { name : '未归档', id : 0 },
            { name : '已归档', id : 1 },
            { name : '进行中', id : 2 }
          ],
        },
        {
          title: '下载状态',
          type: 'select',
          requestKey: 'downloadState',
          label: 'name',
          value: 'id',
          data: [
            { name : '全部', id : "" },
            { name : '未下载', id : 0 },
            { name : '部分下载', id : 2 },
            { name : '已下载', id : 1 }
          ],
          disabled: false
        }
      ],
      requestForm: {
        planId: '',
        enableState: 0,
        archiveState: "",
        downloadState: "",
        page: 1,
        size: 10
      },
      isAddDesc: "",
      downDialog: false,
      showCloseFlag: false,
      planName: "",
      fileList: [],

      /* ***** 表格 ***** */
      tableData: [],
      tableHeader: [
        {
          title: "批次名称",
          width: "200",
          prop: "planName"
        },
        {
          title: "启用状态",
          prop: "planState"
        },
        {
          title: "考试类型",
          prop: "examTypeName"
        },
        {
          title: "可下载文件",
          prop: "archiveFileDesc"
        },
        {
          title: "文件大小",
          prop: "archiveFileSize"
        },
        {
          title: "下载数/总数",
          prop: "twoCount"
        },
        {
          title: "归档状态",
          prop: "archiveStateName"
        },
        {
          title: "归档时间",
          width: "110",
          prop: "archiveDate"
        },
        {
          title: "下载状态",
          prop: "downloadState"
        },
        {
          title: "操作",
          type: "buttons",
          width: 190,
          btnList: [
            //archiveState归档状态（0未归档、1已归档、2进行中）
            //downloadState下载状态（1已下载、0未下载、2部分下载）
            {
              title: "归档",
              click: this.archiveInfo,
              formatter: function(scope) { // 批次停用，未归档，才可以归档
                if(scope.row.planState == "启用"){
                  return true;
                }
                if(scope.row.archiveState == "0" || scope.row.archiveState == null){
                  return false;
                }
                return true;
              },
            },
            {
              title: "下载",
              click: this.archiveDownload,
              formatter: function(scope) { // 批次停用，已归档，才可以下载
                if(scope.row.totalFileCount == null || scope.row.totalFileCount == 0){
                  return true;
                }
                if(scope.row.planState == "停用" && scope.row.archiveState == "1"){
                  return false;
                }
                return true;
              },
            },
            {
              title: "删除批次数据",
              click: this.deleteArchive,
              formatter: function(scope) { //批次停用，已归档，已下载，才可以删除
                return true; //后端代码不完善，先禁用该按钮，回头再开放
                if(
                    scope.row.planState == "停用" &&
                    scope.row.archiveState == "1" &&
                    (
                      scope.row.downloadState == "已下载" ||
                      scope.row.archiveFileDesc == "无归档文件"
                    )
                ){
                  return false;
                }
                return true;
              },
            },
          ],
        },
      ],
      /* ***** 分页 ***** */
      pagination: {
        total: 0,
        page: 1
      }
    };
  },
  mounted() {
    this.getSelectPlan();
    this.getResult();
  },
  watch: {
    'requestForm.archiveState'(newVal) {
      const downloadSelect = this.selectList.find(item => item.requestKey === 'downloadState');
      if (newVal === 1 || newVal === "") {
        downloadSelect.disabled = false;
      } else {
        this.requestForm.downloadState = "";
        downloadSelect.disabled = true;
      }
    }
  },
  methods: {
    searchList() {
      this.requestForm.page = 1;
      this.getResult();
    },
    /********************************
     * @this 获取批次下拉框数据***select***
    ********************************/
    async getSelectPlan() {
      const { data } = await getPagePlan();
      this.selectList[0].data = [ {id: "", name: "请选择"}, ...data ];
    },
    /********************************
     * @this 获取表格数据***table***
     ********************************/
    async getResult() {
      let resultData = await getPlanArchiveListApi(this.requestForm);
      let resultInfo = resultData.data;
      resultInfo.records.forEach((item) => {
        if(item.totalFileCount != null && item.totalFileCount > 0){
          item.twoCount = item.downloadFileCount + "/" + item.totalFileCount;
        }
        if(item.archiveFileSize != null && item.archiveFileSize > 0){
          item.archiveFileSize = this.formatFileSize(item.archiveFileSize);
        }
      });
      this.tableData = resultInfo.records;
      this.pagination.page = resultInfo.current;
      this.pagination.total = resultInfo.total;
    },
    /********************************
     * @this 归档
     ********************************/
    async archiveInfo(row) {
      let {data} = await planArchiveArchiveOperateApi({ planId: row.planId, asyncTag: 1});
      this.$message.success(data);
      this.getResult();
    },
    /********************************
     * @this 下载弹窗
     ********************************/
    archiveDownload(row) {
      // 1. 修改弹窗 标题
      this.isAddDesc = "下载文件";
      // 2. 开启弹窗
      this.downDialog = true;
      // 3.初始化模板名
      this.planName = row.planName;
      getPlanArchiveListFileApi({ planId : row.planId }).then((res) => {
        if (res.code == 1 && res.data) {
          this.fileList = res.data.map(item => ({
            ...item,
            downloadState: row.downloadState
          }));
        }
      });
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0';
      const k = 1024;
      const sizes = ['B', 'K', 'M', 'G', 'T'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    /****************************
     * @this 下载文件
     ***************************/
    async handleDownload(file){
      let params = {
        planArchiveFileId: file.id,
      };
      //下面跑接口就为了记一下日志
      let resultData = await planArchiveDownloadOperateApi(params);
      if (resultData.code == 1) {
        let fileUrl = resultData.data;
        if (fileUrl) {
          file.downloadCount = file.downloadCount + 1;
          if(file.downloadState !== "已下载"){
            //判断文件列表里还有没有下载，数量等于0的
            let willDownCount = this.fileList.filter(item => item.downloadCount == 0).length;
            const row = this.tableData.find(item => item.planId === file.planId);
            if (willDownCount>0) {
              if (row) {
                row.downloadState = "部分下载";
                row.twoCount = row.totalFileCount - willDownCount + "/" + row.totalFileCount;
              }
            }else{
              if (row) {
                row.downloadState = "已下载";
                row.twoCount = row.totalFileCount + "/" + row.totalFileCount;
              }
            }
          }
          window.open(fileUrl,"_blank");
        } else {
          this.$message.error("文件下载失败！");
        }
      }
    },
    /****************************
     * @this 删除批次数据
     ***************************/
    deleteArchive(row) {
      // 1. 删除用户二次确认
      this.$confirm("确认要删除该批次下的所有数据吗？删除后无法恢复，请谨慎操作！", "提示", {
        type: "warning",
      })
        .then(() => {
          planArchiveDeleteOperateApi({ planId: row.planId }).then((res) => {
            if (res.code == 1) {
              this.$message.success("删除成功！");
              this.getResult();
            }
          });
        })
        .catch(() => {});
    },
    /****************************
     * @this 分页相关
     ***************************/
    changeSize(num) {
      this.requestForm.size = num;
      this.getResult();
    },
    changePage(p) {
      this.requestForm.page = p;
      this.getResult();
    },
  },
};
</script>

<style lang="less" scoped>
.searchCon {
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  .searchMain {
    flex: 1;
  }
}

.exportDialog {
  padding: 5px;
  max-height: 60vh;
  overflow-y: auto;

  .batch-name {
    font-size: 15px;
    padding-bottom: 12px;
    margin-bottom: 16px;
    border-bottom: 1px solid #eee;
  }

  .file-table {
    margin-top: 10px;
  }

  .file-icon {
    margin-right: 8px;
    color: #409EFF;
  }

  .file-name {
    vertical-align: middle;
  }

  .file-size, .download-count {
    color: #666;
  }
}
</style>